export default __webpack_public_path__ + "static/banner-home-improvement-getting-the-right-loan-for-the-job-7c654d2e94b9f1bbb27212c5c7d31386.jpg";